module.exports = __webpack_public_path__ + "r-v3/img/ml_42_00_over.3bb64985.jpg";